import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useAssetCardStyle = createUseStyles({
    root: {
        position: 'relative',
        color: color.content.primary,
        padding: `12px 16px`,
        gap: `${spacing['03']}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 'max-content',
        border: `1px solid ${color.border.opaque}`,
        borderRadius: 4,
        marginBottom: spacing['04'],
    },
    assetsWrapper: {
        zIndex: 1,
        position: 'absolute',
        width: '100%',
        maxHeight: '400px',
        overflowX: 'hidden',
        overflowY: 'auto',
        paddingRight: 0,
        border: `1px solid ${color.border.opaque}`,
        backgroundColor: color.background.primary,
        margin: `0 0 ${spacing['04']} 0`,
        borderRadius: 4,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    progress: {
        width: 40,
        height: 40,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing['02'],
    },
    column: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    container: {
        display: 'flex',
        gap: spacing['02'],
        fontWeight: 600,
        '& span': {
            fontSize: 14,
            fontWeight: 400,
        },
    },
    amountWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    amount: {
        fontSize: fontSize.xl,
        fontWeight: 600,
    },
    collateralWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: spacing['03'],

        '& p': {
            margin: 0,
            color: color.content.fourth,
        },
    },
    iconStack: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: 40,
    },
    secondToken: {
        position: 'absolute',
        left: 14,
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    allTokens: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        borderRadius: 100,
        border: `0.857px solid ${color.background.secondary}`,
        background: color.background.tertiary,
        position: 'absolute',
        left: 14,
        fontSize: fontSize.xs,
    },
    tooltip: {
        borderRadius: 4,
        '& .ant-tooltip-inner': {
            padding: `${spacing['03']} ${spacing['05']} ${spacing['03']} ${spacing['04']}`,
            border: `1px solid transparent`,
            background: `${color.background.fourth} !important`,
        },
        '& .ant-tooltip-arrow:before': {
            background: `${color.background.fourth} !important`,
        },
    },
    icon: {
        position: 'absolute',
        left: 14,
        '& img': {
            width: 20,
            height: 20,
        },
    },
    iconWrapper: {
        position: 'relative',
        height: 20,
    },
    assetWithIcon: {
        fontSize: 20,
    },
    input: {
        backgroundColor: 'transparent',
        border: 'none',
        paddingLeft: 0,
        fontSize: 20,
        lineHeight: '28px',
        fontFamily: 'Inter',

        '&:focus': {
            outline: 'none',
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
        },
    },
    info: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            width: 20,
            height: 20,
        },
    },
    buttonMax: {
        color: color.content.inversePrimary,
        backgroundColor: color.background.accent,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '20px',
        borderRadius: '4px',
        fontSize: fontSize.xs,
        cursor: 'pointer',
    },
    closeBtn: {
        cursor: 'pointer',
        position: 'absolute',
        top: '-10px',
        right: '-10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing['02'],
        borderRadius: '50%',
        border: `1px solid ${color.border.opaque}`,
        background: color.background.primary,

        '& svg': {
            width: 10,
            height: 10,
        },
    },
    disabled: {
        cursor: 'not-allowed',
    },
    relative: {
        position: 'relative',
    },
    errorField: {
        border: `1px solid ${color.content.negative} !important`,
        color: color.content.negative,
    },
    error: {
        color: color.content.negative,
        marginTop: spacing['02'],
        fontSize: '12px',
    },
    invalid: {
        borderColor: color.content.negative,
    },
});
